type StepLike = { data?: { requiresSelector?: string } };

/** Keep steps whose `requiresSelector` is missing or present in the DOM. */
export function filterStepsByDom<T extends StepLike>(
  steps: T[],
  has: (sel: string) => boolean
): T[] {
  return steps.filter((step) => {
    const req = step.data?.requiresSelector;
    if (!req) return true;
    return has(req);
  });
}
